{
 "mls": {
  "aus": {
   "espn": "ATX",
   "name": "Austin FC",
   "verified": true
  },
  "dcu": {
   "espn": "DC",
   "name": "D.C. United",
   "verified": true
  },
  "fcc": {
   "espn": "CIN",
   "name": "FC Cincinnati",
   "verified": true
  },
  "laf": {
   "espn": "LAFC",
   "name": "Los Angeles FC",
   "verified": true
  },
  "lag": {
   "espn": "LA",
   "name": "LA Galaxy",
   "verified": true
  },
  "mim": {
   "espn": "MTL",
   "name": "CF Montréal",
   "verified": true
  },
  "nas": {
   "espn": "NSH",
   "name": "Nashville SC",
   "verified": true
  },
  "ner": {
   "espn": "NE",
   "name": "New England Revolution",
   "verified": true
  },
  "nyr": {
   "espn": "RBNY",
   "name": "New York Red Bulls",
   "verified": true
  },
  "sdg": {
   "espn": "SD",
   "name": "San Diego FC",
   "verified": true
  },
  "sje": {
   "espn": "SJ",
   "name": "San Jose Earthquakes",
   "verified": true
  },
  "vwh": {
   "espn": "VAN",
   "name": "Vancouver Whitecaps",
   "verified": true
  }
 },
 "bra": {
  "cre": {
   "espn": "CRU",
   "name": "Cruzeiro",
   "verified": true
  },
  "cor": {
   "espn": "CFC",
   "name": "Coritiba FBC",
   "verified": false
  },
  "cor1": {
   "espn": "COR",
   "name": "SC Corinthians Paulista",
   "verified": false
  }
 },
 "uslc": {
  "bir": {
   "espn": "BRM",
   "name": "Birmingham Legion",
   "verified": true
  },
  "bro": {
   "espn": "BFKC",
   "name": "Brooklyn FC",
   "verified": true
  },
  "cha": {
   "espn": "CHS",
   "name": "Charleston Battery",
   "verified": true
  },
  "css": {
   "espn": "COS",
   "name": "Colorado Springs Switchbacks",
   "verified": true
  },
  "har": {
   "espn": "HFD",
   "name": "Hartford Athletic",
   "verified": true
  },
  "iel": {
   "espn": "INDY",
   "name": "Indy Eleven",
   "verified": true
  },
  "las": {
   "espn": "LVL",
   "name": "Las Vegas Lights",
   "verified": true
  },
  "lcf": {
   "espn": "LOU",
   "name": "Louisville City",
   "verified": true
  },
  "mon": {
   "espn": "MTB",
   "name": "Monterey Bay",
   "verified": true
  },
  "new": {
   "espn": "NMU",
   "name": "New Mexico United",
   "verified": true
  },
  "oc": {
   "espn": "OCSC",
   "name": "Orange County SC",
   "verified": true
  },
  "pho": {
   "espn": "PHX",
   "name": "Phoenix Rising",
   "verified": true
  },
  "rho": {
   "espn": "RHI",
   "name": "Rhode Island FC",
   "verified": true
  },
  "san": {
   "espn": "SAFC",
   "name": "San Antonio FC",
   "verified": true
  },
  "srp": {
   "espn": "SAC",
   "name": "Sacramento Republic",
   "verified": true
  },
  "tam": {
   "espn": "TBR",
   "name": "Tampa Bay Rowdies",
   "verified": true
  },
  "lc": {
   "espn": "LOU",
   "name": "Louisville City FC",
   "verified": false
  },
  "pas": {
   "espn": "ELP",
   "name": "El Paso Locomotive FC",
   "verified": false
  },
  "spo": {
   "espn": "JAX",
   "name": "Sporting Jax",
   "verified": false
  }
 },
 "uel": {
  "ftc": {
   "espn": "FER",
   "name": "Ferencvárosi TC",
   "verified": false
  },
  "pao1": {
   "espn": "PAOK",
   "name": "PAOK",
   "verified": false
  }
 },
 "sud": {
  "boc": {
   "espn": "CABJ",
   "name": "CA Boca Juniors",
   "verified": false
  },
  "cara": {
   "espn": "CFC",
   "name": "Caracas FC",
   "verified": false
  },
  "san1": {
   "espn": "SFE",
   "name": "Independiente Santa Fe",
   "verified": false
  }
 },
 "col": {
  "rij": {
   "espn": "RIJE",
   "name": "HNK Rijeka",
   "verified": false
  },
  "she1": {
   "espn": "SHE",
   "name": "Shelbourne FC",
   "verified": false
  },
  "zri": {
   "espn": "ZRIN",
   "name": "HŠK Zrinjski Mostar",
   "verified": false
  }
 },
 "arg": {
  "aae": {
   "espn": "EST",
   "name": "AA Estudiantes",
   "verified": false
  },
  "aaj": {
   "espn": "ARGJ",
   "name": "AA Argentinos Juniors",
   "verified": false
  },
  "ald": {
   "espn": "ALDO",
   "name": "CA Aldosivi",
   "verified": false
  },
  "cac": {
   "espn": "CTR",
   "name": "CA Central Córdoba",
   "verified": false
  },
  "cah": {
   "espn": "HUR",
   "name": "CA Huracán",
   "verified": false
  },
  "def": {
   "espn": "DYJ",
   "name": "CSyD Defensa y Justicia",
   "verified": false
  },
  "iac": {
   "espn": "IACC",
   "name": "Instituto AC Córdoba",
   "verified": false
  },
  "new": {
   "espn": "NOB",
   "name": "CA Newell's Old Boys",
   "verified": false
  },
  "tal": {
   "espn": "TALL",
   "name": "CA Talleres",
   "verified": false
  },
  "uni": {
   "espn": "USF",
   "name": "CA Unión",
   "verified": false
  }
 },
 "argpn": {
  "ar": {
   "espn": "RAF",
   "name": "Atletico de Rafaela",
   "verified": false
  },
  "caa": {
   "espn": "AGR",
   "name": "Agropecuario Argentino",
   "verified": false
  },
  "cac": {
   "espn": "CHA",
   "name": "Chacarita Juniors",
   "verified": false
  },
  "chi": {
   "espn": "NCHI",
   "name": "Nueva Chicago",
   "verified": false
  },
  "ddb": {
   "espn": "DEF",
   "name": "CA Defensores de Belgrano",
   "verified": false
  },
  "god": {
   "espn": "GCM",
   "name": "CD Godoy Cruz",
   "verified": false
  },
  "sma": {
   "espn": "SMSJ",
   "name": "San Martin de San Juan",
   "verified": false
  },
  "smt": {
   "espn": "SAN",
   "name": "San Martin de Tucuman",
   "verified": false
  }
 },
 "mex": {
  "atl": {
   "espn": "ATS",
   "name": "Atlas FC",
   "verified": false
  },
  "atla": {
   "espn": "ATL",
   "name": "Atlante FC",
   "verified": false
  },
  "gua": {
   "espn": "GDL",
   "name": "CD Guadalajara",
   "verified": false
  },
  "mon1": {
   "espn": "MTY",
   "name": "CF Monterrey",
   "verified": false
  },
  "pum": {
   "espn": "UNAM",
   "name": "Pumas de la UNAM",
   "verified": false
  },
  "que": {
   "espn": "QRO",
   "name": "Querétaro FC",
   "verified": false
  },
  "tig": {
   "espn": "UANL",
   "name": "Tigres de la UANL",
   "verified": false
  }
 },
 "col1": {
  "adc": {
   "espn": "DCI",
   "name": "AD Cali",
   "verified": false
  },
  "adp": {
   "espn": "PAS",
   "name": "AD Pasto",
   "verified": false
  },
  "alf": {
   "espn": "AFC",
   "name": "Alianza FC",
   "verified": false
  },
  "cab": {
   "espn": "BUC",
   "name": "CA Bucaramanga",
   "verified": false
  },
  "cdt": {
   "espn": "TOL",
   "name": "CD Tolima",
   "verified": false
  },
  "dep": {
   "espn": "PER",
   "name": "Deportivo Pereira",
   "verified": false
  },
  "foc": {
   "espn": "FOR",
   "name": "Fortaleza CEIF",
   "verified": false
  },
  "gdr": {
   "espn": "AGD",
   "name": "Águilas Doradas Rionegro",
   "verified": false
  },
  "inm": {
   "espn": "DIM",
   "name": "Independiente Medellín",
   "verified": false
  },
  "llf": {
   "espn": "LLA",
   "name": "Llaneros FC",
   "verified": false
  },
  "mif": {
   "espn": "MIL",
   "name": "Millonarios FC",
   "verified": false
  }
 },
 "chi": {
  "bgu": {
   "espn": "BG",
   "name": "Beijing Guoan FC",
   "verified": false
  },
  "hai": {
   "espn": "QIN",
   "name": "Qingdao Hainiu FC",
   "verified": false
  },
  "jin": {
   "espn": "TIG",
   "name": "Tianjin Jinmen Hu FC",
   "verified": false
  },
  "ron": {
   "espn": "CHE",
   "name": "Chengdu Rongcheng FC",
   "verified": false
  },
  "sgr": {
   "espn": "SHE",
   "name": "Shanghai Shenhua FC",
   "verified": false
  },
  "sha": {
   "espn": "SHT",
   "name": "Shandong Taishan FC",
   "verified": false
  },
  "tie": {
   "espn": "LIA",
   "name": "Liaoning Tieren FC",
   "verified": false
  },
  "ton": {
   "espn": "CHO",
   "name": "Chongqing Tonglianglong FC",
   "verified": false
  },
  "xin": {
   "espn": "SHX",
   "name": "Shenzhen Xinpengcheng FC",
   "verified": false
  },
  "ygb": {
   "espn": "DYI",
   "name": "Dalian Yingbo FC",
   "verified": false
  }
 },
 "chi1": {
  "ccu": {
   "espn": "COQ",
   "name": "CD Coquimbo Unido",
   "verified": false
  },
  "cdc": {
   "espn": "COB",
   "name": "CD Cobresal",
   "verified": false
  },
  "cdl": {
   "espn": "LIM",
   "name": "CD Limache",
   "verified": false
  },
  "cdp": {
   "espn": "PAL",
   "name": "CD Palestino",
   "verified": false
  },
  "cdu": {
   "espn": "ÑUB",
   "name": "CD Ñublense",
   "verified": false
  },
  "csc": {
   "espn": "COL",
   "name": "CSD Colo-Colo",
   "verified": false
  },
  "cu1": {
   "espn": "UdeC",
   "name": "CD Universidad de Concepción",
   "verified": false
  },
  "cul": {
   "espn": "ULC",
   "name": "CD Unión La Calera",
   "verified": false
  },
  "edv": {
   "espn": "EVE",
   "name": "Everton de Viña del Mar",
   "verified": false
  }
 },
 "per1": {
  "caa": {
   "espn": "AAT",
   "name": "Club Alianza Atlético",
   "verified": false
  },
  "cag": {
   "espn": "AGR",
   "name": "CA Grau",
   "verified": false
  },
  "cal": {
   "espn": "ALM",
   "name": "Club Alianza Lima",
   "verified": false
  },
  "ccu": {
   "espn": "CMU",
   "name": "CD Comerciantes Unidos",
   "verified": false
  },
  "clc": {
   "espn": "CHAN",
   "name": "CD Los Chankas",
   "verified": false
  },
  "csh": {
   "espn": "SHO",
   "name": "CS Huancayo",
   "verified": false
  },
  "cuf": {
   "espn": "CFC",
   "name": "Cusco FC",
   "verified": false
  }
 },
 "uru1": {
  "cla": {
   "espn": "CERR",
   "name": "Cerro Largo FC",
   "verified": false
  },
  "tor": {
   "espn": "MCT",
   "name": "Montevideo City Torque",
   "verified": false
  }
 },
 "ecu1": {
  "cse": {
   "espn": "EME",
   "name": "CS Emelec",
   "verified": false
  },
  "mur": {
   "espn": "MUS",
   "name": "Mushuc Runa SC",
   "verified": false
  },
  "sda": {
   "espn": "AUC",
   "name": "SD Aucas",
   "verified": false
  },
  "tec": {
   "espn": "TUA",
   "name": "CD Tecnico Universitario",
   "verified": false
  }
 },
 "rus": {
  "akr": {
   "espn": "AKT",
   "name": "FK Akron Tolyatti",
   "verified": false
  },
  "lok": {
   "espn": "LMO",
   "name": "FK Lokomotiv Moskva",
   "verified": false
  }
 },
 "nor": {
  "ffk": {
   "espn": "FRE",
   "name": "Fredrikstad FK",
   "verified": false
  },
  "ik": {
   "espn": "IKS",
   "name": "IK Start",
   "verified": false
  },
  "vif": {
   "espn": "VAL",
   "name": "Vålerenga Fotball",
   "verified": false
  }
 },
 "swe": {
  "hac": {
   "espn": "BKH",
   "name": "BK Hacken",
   "verified": false
  },
  "ifk": {
   "espn": "GOT",
   "name": "IFK Goteborg",
   "verified": false
  },
  "kal": {
   "espn": "KFF",
   "name": "Kalmar FF",
   "verified": false
  }
 },
 "den": {
  "hor": {
   "espn": "ACH",
   "name": "AC Horsens",
   "verified": false
  },
  "lyn": {
   "espn": "LBK",
   "name": "Lyngby BK",
   "verified": false
  },
  "nor": {
   "espn": "FCN",
   "name": "FC Nordsjælland",
   "verified": false
  }
 },
 "scop": {
  "fal": {
   "espn": "FALK",
   "name": "Falkirk FC",
   "verified": false
  },
  "hmi": {
   "espn": "HOM",
   "name": "Heart of Midlothian FC",
   "verified": false
  }
 },
 "aut": {
  "ask": {
   "espn": "LAS",
   "name": "LASK Linz",
   "verified": false
  },
  "gak": {
   "espn": "GRA",
   "name": "Grazer AK 1902",
   "verified": false
  },
  "htb": {
   "espn": "HAR",
   "name": "TSV Hartberg",
   "verified": false
  },
  "rbs": {
   "espn": "SLZ",
   "name": "FC Salzburg",
   "verified": false
  },
  "stu": {
   "espn": "STG",
   "name": "SK Sturm Graz",
   "verified": false
  }
 },
 "nwsl": {
  "ang": {
   "espn": "LA",
   "name": "Angel City FC",
   "verified": false
  },
  "cou": {
   "espn": "NC",
   "name": "North Carolina Courage",
   "verified": false
  },
  "das": {
   "espn": "HOU",
   "name": "Houston Dash",
   "verified": false
  },
  "got": {
   "espn": "GFC",
   "name": "NJ/NY Gotham FC",
   "verified": false
  },
  "kcc": {
   "espn": "KC",
   "name": "Kansas City Current",
   "verified": false
  },
  "pri": {
   "espn": "ORL",
   "name": "Orlando Pride",
   "verified": false
  },
  "rac": {
   "espn": "LOU",
   "name": "Racing Louisville FC",
   "verified": false
  },
  "rei": {
   "espn": "SEA",
   "name": "Seattle Reign FC",
   "verified": false
  },
  "roy": {
   "espn": "UTA",
   "name": "Utah Royals FC",
   "verified": false
  },
  "spi": {
   "espn": "WAS",
   "name": "Washington Spirit",
   "verified": false
  }
 }
}
